import {
  APIProvider,
  Map as GoogleMap,
  AdvancedMarker,
  Pin,
  InfoWindow,
} from '@vis.gl/react-google-maps';
import { useState } from 'react';

interface Marker {
  id: string;
  name: string;
  position: {
    lat: number;
    lng: number;
  };
  description?: string;
  endereco?: string;
  telefone?: string;
}

interface SimpleMapProps {
  markers: Marker[];
  mapId?: string;
}

const SimpleMap: React.FC<SimpleMapProps> = ({ markers, mapId }) => {
  const [openMarkerId, setOpenMarkerId] = useState<string | null>(null);

  const apiKey = process.env.REACT_APP_GOOGLE_API_TOKEN;
  const defaultMapId = process.env.REACT_APP_GOOGLE_MAP_ID;

  if (!apiKey) {
    console.error('API Key do Google Maps não definida!');
    return (
      <div className="p-4 bg-red-100 text-red-700 rounded">
        Erro: API Key do Google Maps não definida.
      </div>
    );
  }

  const center =
    markers.length > 0 ? markers[0].position : { lat: -15.7801, lng: -47.9292 };

  return (
    <APIProvider apiKey={apiKey}>
      <div className="w-full h-[400px] rounded-md overflow-hidden">
        <GoogleMap
          center={center}
          zoom={11}
          minZoom={5}
          mapId={mapId || defaultMapId}
          style={{ width: '100%', height: '100%' }}
        >
          {markers.map(marker => (
            <AdvancedMarker
              key={marker.id}
              position={marker.position}
              onClick={() =>
                setOpenMarkerId(prev => (prev === marker.id ? null : marker.id))
              }
            >
              <Pin background="#3B82F6" glyphColor="white" />
              {openMarkerId === marker.id && (
                <InfoWindow onCloseClick={() => setOpenMarkerId(null)}>
                  <div className="p-2 text-sm">
                    <h4 className="font-bold text-blue-700">{marker.name}</h4>
                    {marker.description && (
                      <p className="text-gray-700">{marker.description}</p>
                    )}
                    {marker.endereco && (
                      <p className="text-gray-600">
                        <strong>Endereço:</strong> {marker.endereco}
                      </p>
                    )}
                    {marker.telefone && (
                      <p className="text-gray-600">
                        <strong>Telefone:</strong> {marker.telefone}
                      </p>
                    )}
                  </div>
                </InfoWindow>
              )}
            </AdvancedMarker>
          ))}
        </GoogleMap>
      </div>
    </APIProvider>
  );
};

export default SimpleMap;
